"use strict";

//const assert =  require("assert")

class DeliveryApi {
    constructor (shopid, url) {
        this.shopid = shopid
        this.url = url

        this._apirequest = async (method, body) => {
            let response = undefined
            try{
                if (body){
                    response = await fetch(this.url+'/'+method, {
                        method: 'POST',
                        headers:{
                            shopid:this.shopid,
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(body)
                    })
                } else {
                    response = await fetch(this.url+'/'+method, {headers:{shopid:this.shopid}})
                }
            } catch {
                throw "В данный момент ресторан не принимает заказы онлайн. Пожалуйста, повторите попытку позднее."
            }
                
            let data = await response.json();
            if (!data.result){
                console.error('Response for '+method+': '+data.msg)
                throw data.msg
            } else {
                return data
            }
        }

        this.getmenu = async () => {
            return await this._apirequest('getmenu')
        }

        this.validate = async (cart) => {
            return await this._apirequest('validate', cart)
        }

        this.invoice = async (payload) => {
            return await this._apirequest('invoice', payload)
        }

        this.status = async (invoice) => {
            return await this._apirequest('invoicestatus', invoice)
        }

        this.suggest = async (query) => {
            return await this._apirequest('suggest', {query})
        }
    }
}

export default DeliveryApi